/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'system';
const componentName = 'dns-services-grid';
const prefix = `${moduleName}.${componentName}`;

export const headerLabel = `${prefix}.headerLabel`;
export const gridTitleDnsServices = `${prefix}.gridTitleDnsServices`;
export const columnTitleVirtualService = `${prefix}.columnTitleVirtualService`;

export const ENGLISH = {
    [headerLabel]: 'Edit System Settings',
    [gridTitleDnsServices]: 'DNS Services',
    [columnTitleVirtualService]: 'Virtual Service',
};
